<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="标题：">
            <el-input
              v-model="query.title"
              placeholder="请输入标题"
              clearable
              size="small"
            />
          </el-form-item>
          <el-form-item label="内容类型：">
            <el-select
              v-model="query.type"
              placeholder="请选择"
              clearable
              size="small"
            >
              <el-option label="线上资料" :value="1"></el-option>
              <el-option label="线下物料" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select
              v-model="query.isEnable"
              placeholder="请选择"
              clearable
              size="small"
            >
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布时间：">
            <el-date-picker
              v-model="createdTimeRange"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini"
              >搜索</el-button
            >
            <el-button type="info" @click="handleFilter" plain size="mini"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini"
              >批量操作<i class="el-icon--right el-icon-arrow-down"></i
            ></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">批量启用</el-dropdown-item>
              <el-dropdown-item :command="2">批量禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            type="primary"
            size="mini"
            @click="handleCreate"
            icon="el-icon-plus"
            >新增</el-button
          >
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="list"
        @selection-change="selectionChange"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="50" />
        <!-- <el-table-column label="id" prop="id" align="center" /> -->
        <el-table-column label="标题" align="center" width="200" fixed="left">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="handleShow(row, 2)">
              {{
                row.templateMaterialsSharePO &&
                row.templateMaterialsSharePO.type === 4
                  ? (row.courseSubjectPO && row.courseSubjectPO.name) ||
                    row.templateMaterialsSharePO.courseSubjectName ||
                    "-"
                  : (row.templateMaterialsSharePO &&
                      row.templateMaterialsSharePO.title) ||
                    "-"
              }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="封面图" prop="icon" align="center">
          <template slot-scope="{ row }">
            <el-image
              v-if="
                row.templateMaterialsSharePO &&
                  row.templateMaterialsSharePO.coverImage
              "
              style="width: 50px; height: 50px"
              :src="row.templateMaterialsSharePO.coverImage"
              :preview-src-list="[row.templateMaterialsSharePO.coverImage]"
            ></el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="内容类型" align="center" min-width="100">
          <template slot-scope="{ row }">
            {{
              row.templateMaterialsSharePO &&
              row.templateMaterialsSharePO.type === 1
                ? "线上资料"
                : "线下物料"
            }}
          </template>
        </el-table-column>
        <!-- 线上资料=图片集合，条数有意义；线下物料是富文本+网盘链接，没有"物料条数"这个概念，
             原来一律读 materialImg 长度，线下恒显示 0，被当成"共0项物料"的错误提示。 -->
        <el-table-column label="包内容" align="center" min-width="120">
          <template slot-scope="{ row }">
            {{ packageContentText(row) }}
          </template>
        </el-table-column>
        <el-table-column label="分类 " align="center" min-width="100">
          <template slot-scope="{ row }">
            {{
              (row.templateClassification && row.templateClassification.name) ||
                "-"
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          prop="isEnable"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.isEnable"
              :active-value="true"
              :inactive-value="false"
              @change="changeSwitch(row)"
            ></el-switch
            >{{
              row.templateMaterialsSharePO &&
              row.templateMaterialsSharePO.state === 1
                ? "启用"
                : "禁用"
            }}
          </template>
        </el-table-column>
        <el-table-column label="推荐" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.isRecommend"
              :active-value="1"
              :inactive-value="0"
              @change="changeRecommend(row)"
            ></el-switch
            >{{ row.isRecommend === 1 ? "推荐" : "未推荐" }}
          </template>
        </el-table-column>
        <el-table-column label="排序" align="center">
          <template slot-scope="{ row }">{{
            (row.templateMaterialsSharePO &&
              row.templateMaterialsSharePO.orderNo) ||
              "-"
          }}</template>
        </el-table-column>
        <el-table-column label="浏览量" align="center">
          <template slot-scope="{ row }">{{
            (row.templateMaterialsSharePO &&
              row.templateMaterialsSharePO.abrowseNum) ||
              0
          }}</template>
        </el-table-column>
        <el-table-column label="点赞量" align="center">
          <template slot-scope="{ row }">{{
            (row.templateMaterialsSharePO &&
              row.templateMaterialsSharePO.alikeNum) ||
              0
          }}</template>
        </el-table-column>
        <el-table-column label="收藏量" align="center">
          <template slot-scope="{ row }">{{
            (row.templateMaterialsSharePO &&
              row.templateMaterialsSharePO.acollectNum) ||
              0
          }}</template>
        </el-table-column>
        <el-table-column label="转发量" align="center">
          <template slot-scope="{ row }">{{
            (row.templateMaterialsSharePO &&
              row.templateMaterialsSharePO.aforwardNum) ||
              0
          }}</template>
        </el-table-column>
        <el-table-column
          label="分享素材 "
          prop="materialTexts"
          align="center"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column label="下载次数 " prop="orderNo" align="center" />
        <el-table-column label="发布时间" sortable="custom" align="center" width="200">
          <template slot-scope="{ row }">
            {{ (row.templateMaterialsSharePO && row.templateMaterialsSharePO.createdTime) || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作时间"
          prop="operatedTime"
          sortable="custom"
          align="center"
          width="200"
        >
          <template slot-scope="{ row }">
            {{
              (row.templateMaterialsSharePO &&
                row.templateMaterialsSharePO.operatedTime) ||
                "-"
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operatedName" align="center">
          <template slot-scope="{ row }">
            {{ (row.operatedUserPO && row.operatedUserPO.realName) || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)"
              >删除</el-button
            >
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :pageNo.sync="query.pageNo"
        :pageSize.sync="query.pageSize"
        @pagination="doQueryList"
      />
    </el-card>
    <!-- 新建表单 -->
    <classify-add
      ref="classifyAdd"
      @created="doQueryList({})"
      :menuOptions="list"
    />
  </div>
</template>

<script>
import classifyAdd from "./add";
import templateMaterialsShareApi from "@/api/marketing/templateMaterialsShare";
import Pagination from "@/components/Pagination";

export default {
  components: {
    Pagination,
    classifyAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        // 默认按发布时间倒序：排序号后台没人维护（全是0），按它排新上传的会沉底，
        // BUG-2026-582095 在 App 端已因此改成上传时间倒序，管理端保持同一口径。
        createdTimeSortSign: -1
      },
      selectItems: [],
      createdTimeRange: null
    };
  },
  created() {
    this.doQueryList({ pageNo: 1 });
  },
  methods: {
    /** 包内物料条数 = materialImg 这个 JSON 数组的长度 */
    /** 线上资料的图片张数；解析不出按 0 */
    materialCount(row) {
      const raw =
        row.templateMaterialsSharePO && row.templateMaterialsSharePO.materialImg;
      if (!raw) return 0;
      try {
        const list = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(list) ? list.length : 0;
      } catch (e) {
        return 0;
      }
    },
    /**
     * 「包内容」列：线上和线下的内容形态本来就不同，不能套同一个计数口径。
     *  - 线上资料(type=1)：一包若干张图片，显示"N 张图片"
     *  - 线下物料(type=3)：后台配的是富文本详情 + 网盘链接，没有"物料条数"，
     *    显示实际配了什么，避免恒显示 0 让人以为"共 0 项物料/物料没加上"
     */
    packageContentText(row) {
      const po = row.templateMaterialsSharePO || {};
      if (po.type === 3) {
        const parts = [];
        if (po.content) parts.push("图文详情");
        if (po.otherUrl) parts.push("网盘链接");
        return parts.length ? parts.join(" + ") : "未配置内容";
      }
      const count = this.materialCount(row);
      return count > 0 ? count + " 张图片" : "未配置图片";
    },
    handleShow(row) {
      this.$emit("handleShow", row, 2);
    },
    handleFilter() {
      // 重置也要保住默认排序，否则重置后列表变成无序
      this.query = { createdTimeSortSign: -1 };
      this.createdTimeRange = null;
      this.doQueryList({ pageNo: 1, pageSize: 10 });
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val;
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        createdTime: "createdTimeSortSign",
        operatedTime: "operatedTimeSortSign"
      };
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k];
        if (k !== prop) {
          this.query[sortKey] = null;
        } else {
          if (order === "ascending") {
            this.query[sortKey] = 1;
          } else {
            this.query[sortKey] = -1;
          }
        }
      }
      this.doQueryList({});
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo;
      }
      if (pageSize) {
        this.query.pageSize = pageSize;
      }
      // 1分享物料 2项目管理 3顾客物料 4案例展示 5业务物料 6品宣 7皮科药普 8新闻资讯 9患者就诊物料 10项目落地
      const queryParams = {
        ...this.query,
        sourceType: 10
      };
      if (queryParams.isEnable !== undefined) {
        queryParams.state = queryParams.isEnable ? 1 : 0;
        delete queryParams.isEnable;
      }
      // 处理发布时间范围
      if (this.createdTimeRange && this.createdTimeRange.length === 2) {
        queryParams.createdTimeStart = this.createdTimeRange[0];
        queryParams.createdTimeEnd = this.createdTimeRange[1];
      } else {
        queryParams.createdTimeStart = undefined;
        queryParams.createdTimeEnd = undefined;
      }
      this.listLoading = true;
      return templateMaterialsShareApi
        .fetchList(queryParams)
        .then(data => {
          const list = data.data.list || [];
          list.forEach(item => {
            if (item.templateMaterialsSharePO) {
              item.isEnable = item.templateMaterialsSharePO.state === 1;
              item.isRecommend = item.templateMaterialsSharePO.isRecommend === 1 ? 1 : 0;
              if (item.templateMaterialsSharePO.materialText) {
                try {
                  const materialText =
                    item.templateMaterialsSharePO.materialText || "";
                  item.materialTexts = JSON.parse(materialText).join(",");
                } catch (e) {
                  item.materialTexts = "";
                }
              }
            }
          });
          this.list = list;
          this.total = data.data.total || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      const id =
        row.id ||
        (row.templateMaterialsSharePO && row.templateMaterialsSharePO.id);
      if (!id) return;
      return this.$common
        .confirm("是否确认删除")
        .then(() => templateMaterialsShareApi.deleteById({ ids: id }))
        .then(() => {
          this.$common.showMsg("success", "删除成功");
          return this.doQueryList({ pageNo: 1 });
        });
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg("warning", "请选择分类");
        return;
      }
      const ids = this.selectItems
        .map(
          row =>
            row.id ||
            (row.templateMaterialsSharePO && row.templateMaterialsSharePO.id)
        )
        .filter(Boolean);
      return this.$common
        .confirm("是否确认删除")
        .then(() =>
          templateMaterialsShareApi.deleteBatch({ ids: ids.join(",") })
        )
        .then(() => {
          this.$common.showMsg("success", "删除成功");
          return this.doQueryList({ pageNo: 1 });
        });
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg("warning", "请选择分类");
        return;
      }
      const ids = this.selectItems
        .map(
          row =>
            row.id ||
            (row.templateMaterialsSharePO && row.templateMaterialsSharePO.id)
        )
        .filter(Boolean);
      if (command === 1) {
        this.handleBatchState(ids, 1);
      } else if (command === 2) {
        this.handleBatchState(ids, 0);
      }
    },
    handleBatchState(ids, type) {
      const txt =
        type === 1 ? "确认将选中分类批量启用？" : "确认将选中分类批量禁用？";
      this.$common
        .confirm(txt)
        .then(() =>
          templateMaterialsShareApi.setIsEnableBatch({
            ids: Array.isArray(ids) ? ids.join(",") : ids,
            state: type ? 1 : 0
          })
        )
        .then(() => {
          this.$common.showMsg("success", "操作成功");
          return this.doQueryList({ pageNo: 1 });
        });
    },
    changeSwitch(row) {
      const id =
        row.id ||
        (row.templateMaterialsSharePO && row.templateMaterialsSharePO.id);
      if (!id) return;
      templateMaterialsShareApi
        .setIsEnable({
          ids: id,
          state: row.isEnable ? 1 : 0
        })
        .then(() => {
          this.$common.showMsg("success", "操作成功");
        });
    },
    /** 推荐开关：单条走批量接口，App 端「最近更新」优先展示已推荐内容 */
    changeRecommend(row) {
      const id =
        row.id ||
        (row.templateMaterialsSharePO && row.templateMaterialsSharePO.id);
      if (!id) return;
      templateMaterialsShareApi
        .updateIsRecommendBatch({
          ids: id,
          isRecommend: row.isRecommend ? 1 : 0
        })
        .then(() => {
          this.$common.showMsg("success", "操作成功");
        });
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.classifyAdd.handleCreate(row);
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.classifyAdd.handleUpdate(row);
    },
    /**
     * 查看日志记录
     */
    handleLog(row) {
      const id =
        row.id ||
        (row.templateMaterialsSharePO && row.templateMaterialsSharePO.id);
      if (!id) return;
      this.$router.push("/log/log?type=122&id=" + id);
    }
  }
};
</script>
<style lang="scss" scoped>
.el-switch {
  margin-right: 6px;
}
</style>
